import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter, Link} from "react-router-dom";
import { Grid } from '@material-ui/core';
import { Add } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import _ from 'lodash';
import { getHedgeByDealIdAndStatus } from "store/state/hedge";

import { ActiveHedgeComponent } from "./ActiveHedgeComponent";

import hedgeStatus from "constants/hedgeStatus";
import { StyledActionButton,StyledLinkButton, styles,SectionFragment,SubSectionFragment, ToggleButtonsFragment } from "../styles";
import { ViewHeader } from "../util";

class HedgeView extends React.Component {
    state = {
        selectedActiveHedge: null,
        selectedWatchHedge: null,
        selectedTerminatedHedge: null,
        dealId: "free",
        fundId: "free",
        showWatchHedges: false,   
        showTerminatedHedges: false, 
    }

    componentDidMount = (prevProps, prevState, snapshot) => {   
        this.props.getHedgeByDealIdAndStatus(
            {
              dealId: this.props.dealId,
              hedgeStatus: hedgeStatus.ACTIVE,
            }
          );
      const {location, match} = this.props;

      this.setState({
        dealId: match.params.dealId,
        fundId: match.params.fundId,
        selectedActiveHedge: null,
        selectedWatchHedge: null,
        selectedTerminatedHedge: null,
      })
    }

    componentDidUpdate = () =>{
        const {terminatedHedges, activeHedges, watchHedges} = this.props;
        this.selectInitial("selectedActiveHedge", this.state.selectedActiveHedge, activeHedges, "effectiveDate");
        this.selectInitial("selectedWatchHedge", this.state.selectedWatchHedge, watchHedges, "effectiveDate");
        this.selectInitial("selectedTerminatedHedge", this.state.selectedTerminatedHedge, terminatedHedges, "earlyTerminationDate");
    }
    
    handleSelect = (hedgeType, hedge) => {
        if(hedge)
            this.setState({[hedgeType]: hedge});
    }
    showWatchHedges =()=>{
        if(!this.state.showWatchHedges){
            this.props.getHedgeByDealIdAndStatus(
                {
                dealId: this.props.dealId,
                hedgeStatus: hedgeStatus.WATCH,
                }
            );
        }
        this.setState({
            showWatchHedges: !this.state.showWatchHedges,      
        });
      }
    showHideTerminatedHedges =()=>{
        if(!this.state.showTerminatedHedges){
            this.props.getHedgeByDealIdAndStatus(
                {
                dealId: this.props.dealId,
                hedgeStatus: hedgeStatus.TERMINATED,
                }
            );
        }
        this.setState({
          showTerminatedHedges: !this.state.showTerminatedHedges,      
        });
      }

    selectInitial(selectedStatus, selectedHedge, items, dateField)  {
        if (items && (!selectedHedge || (selectedHedge && _.indexOf(items, selectedHedge) === -1))) {
            let initialSelectedItem = items.sort((a, b) => moment.utc(a[dateField]).unix() - moment.utc(b[dateField]).unix())[0];
            this.handleSelect(selectedStatus, initialSelectedItem);
        } 
    }
    
    hedgeDealIdCheck(){
        const { dealId } = this.state;
        const {activeHedges} = this.props;
        if(!activeHedges || activeHedges.length === 0) return true;
        return activeHedges.some(e => e.dealId == dealId);
    }

    render() {        
        const { selectedActiveHedge, selectedTerminatedHedge,selectedWatchHedge, fundId, dealId, showWatchHedges, showTerminatedHedges} = this.state;
        const { activeHedges, terminatedHedges, watchHedges,guestPermissions,authentication } = this.props;
        const newHedgeButton = (!authentication.isGuest) && (<StyledActionButton id="newHedgeButton"variant="contained" component={Link} to={`/hedge/${fundId}/${dealId}`}>
                                    <Add />New Hedge
                                </StyledActionButton>);

        if(!this.hedgeDealIdCheck()) return null;

        return (
            <SectionFragment>
                <SubSectionFragment>

                    <ViewHeader TitleText="Hedges" children={newHedgeButton} />

                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                        <ActiveHedgeComponent
                            hedges={activeHedges}
                            handleSelect={(hedge) => this.handleSelect("selectedActiveHedge",hedge)}
                            selectedHedge={selectedActiveHedge}
                            Link={Link}
                            fundId={fundId}
                            dealId={dealId}
                            hedgeStatusId={hedgeStatus.ACTIVE}/>
                    </Grid>
                </SubSectionFragment>

                {(!authentication.isGuest || (authentication.isGuest && guestPermissions.accessLevel === "Full")) && 
                <Fragment>
                    <ToggleButtonsFragment>
                        <Grid container direction="row" justify="flex-start" alignItems="center">
                            <Grid item sm={12}>
                                <StyledLinkButton id="watchHedgesShowHideButton" variant="contained" onClick={this.showWatchHedges}>{showTerminatedHedges ? "HIDE" : "SHOW"} Watch Hedges</StyledLinkButton>
                            </Grid>
                        </Grid>   
                        {!showWatchHedges || 
                            <Grid className={this.props.classes.toggleMargin} container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                                <ActiveHedgeComponent
                                    hedges={watchHedges}
                                    handleSelect={(hedge) => this.handleSelect("selectedWatchHedge",hedge)}
                                    selectedHedge={selectedWatchHedge}
                                    Link={Link}
                                    fundId={fundId}
                                    dealId={dealId}
                                    hedgeStatusId={hedgeStatus.WATCH}/>
                            </Grid>}
                    </ToggleButtonsFragment>
                    <ToggleButtonsFragment>
                        <Grid container direction="row" justify="flex-start" alignItems="center">
                            <Grid item sm={12}>
                                <StyledLinkButton id="terminatedHedgesShowHideButton" variant="contained" onClick={this.showHideTerminatedHedges}>{showTerminatedHedges ? "HIDE" : "SHOW"} Terminated Hedges</StyledLinkButton>
                            </Grid>
                        </Grid>   
                        {!showTerminatedHedges || 
                            <Grid className={this.props.classes.toggleMargin} container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                                <ActiveHedgeComponent
                                    hedges={terminatedHedges}
                                    handleSelect={(hedge) => this.handleSelect("selectedTerminatedHedge",hedge)}
                                    selectedHedge={selectedTerminatedHedge}                                
                                    Link={Link}
                                    fundId={fundId}
                                    dealId={dealId}
                                    hedgeStatusId={hedgeStatus.TERMINATED}/>
                            </Grid>}
                    </ToggleButtonsFragment>
                </Fragment>}
            </SectionFragment>)
        }
}

const mapStateToProps = ({ authentication, hedge }) => ({
    authentication,    
    activeHedges: hedge.hedgeByStatus[hedgeStatus.ACTIVE] ? hedge.hedgeByStatus[hedgeStatus.ACTIVE].hedges : null,
    terminatedHedges: hedge.hedgeByStatus[hedgeStatus.TERMINATED] ? hedge.hedgeByStatus[hedgeStatus.TERMINATED].hedges : null,
    watchHedges: hedge.hedgeByStatus[hedgeStatus.WATCH] ? hedge.hedgeByStatus[hedgeStatus.WATCH].hedges : null,
});

export default compose( 
  withRouter,
  connect( mapStateToProps,{ getHedgeByDealIdAndStatus } ),withStyles(styles) ) (HedgeView);